// Enable menu tags - DESKTOP

        document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu__link--main, .m-menu__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

      document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu__link--main, .m-menu__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/trending\/\//g, '<span class="trendingTag">HOT</span>');
            });
        });

// enable menu tags - mobile

document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu-mobile__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

        document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu-mobile__back-button');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.list-none a');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

document.addEventListener('DOMContentLoaded', function () {
    // Get all elements containing the text '&lt;new&gt;'
    const elements = document.querySelectorAll('.m-menu-mobile__link');
    
    elements.forEach(function(element) {
        // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
        element.innerHTML = element.innerHTML.replace(/\/\/trending\/\//g, '<span class="trendingTag">HOT</span>');
    });
});
